import { Stack } from '@mui/material'
import { KpiSelector } from './KpiSelector'
import { DriverSelector } from './DriverSelector'
import { ValueTypeSelector } from './ValueTypeSelector'
import { FixedAxisChip } from './FixedAxisChip'
import type { KpiCascadeState } from '~/state/useKpiCascadeState'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  state: KpiCascadeState
}

export function KpiCascade({ state }: Props) {
  // flexWrap: the cascade lives inside the V7 KPI ControlCard — without wrap its
  // driver/value-type elements overflow the card edge under the neighbor card.
  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap alignItems="center">
      <KpiSelector options={state.rootOptions} value={state.root} onChange={state.setRoot} />

      {/* Driver: a real choice only when >1 option. One option = fixed context -> read-only chip;
          zero = a bare root on a 3-axis page -> render nothing. */}
      {state.axisCount >= 2 && state.driverOptions.length > 1 && (
        <DriverSelector
          options={state.driverOptions}
          value={state.driver ?? ''}
          onChange={state.setDriver}
        />
      )}
      {state.axisCount >= 2 && state.driverOptions.length === 1 && (
        <FixedAxisChip label={CONTROLS.driver} value={state.driverOptions[0]!.label} />
      )}

      {/* Value Type: same single-vs-multi rule. */}
      {state.axisCount === 3 && state.valueTypeOptions.length > 1 && (
        <ValueTypeSelector
          options={state.valueTypeOptions}
          value={state.valueType ?? ''}
          onChange={state.setValueType}
        />
      )}
      {state.axisCount === 3 && state.valueTypeOptions.length === 1 && (
        <FixedAxisChip label={CONTROLS.valueType} value={state.valueTypeOptions[0]!.label} />
      )}
    </Stack>
  )
}
